import React from 'react';
import { Card, CardContent, Container, Typography } from '@mui/material';
import { useEffect } from 'react';

export const About = () => {
    useEffect(() => {
    document.title = "About Us - Pest Control Raipur Services";
  }, []);
  
  return (
  <Container>
    <Card variant="outlined" sx={{ mt: 4, p: 3 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>About Pest Control Raipur Services</Typography>
        <Typography variant="body1">
          Pest Control Raipur Services is a leading provider of pest control solutions in Raipur, Chhattisgarh. With years of experience in the industry, we are committed to delivering effective and reliable pest management services to both residential and commercial clients.
        </Typography>
        <Typography variant="body1">
          Our team of highly trained and certified professionals uses the latest techniques and eco-friendly products to ensure the safety and well-being of our clients. We understand the importance of a pest-free environment and strive to provide customized solutions that meet the unique needs of each customer.
        </Typography>
        <Typography variant="body1">
          At Pest Control Raipur Services, we offer a wide range of services including termite treatment, cockroach control, rodent control, bed bug treatment, and more. Our goal is to protect your home and business from unwanted pests and to provide you with peace of mind.
        </Typography>
        <Typography variant="body1">
          We believe in building long-term relationships with our clients through exceptional service and customer satisfaction. Our team is always ready to assist you with any pest-related issues and to provide you with the best possible solutions.
        </Typography>
        <Typography variant="body1">
          Contact us today to learn more about our services and how we can help you maintain a pest-free environment.
        </Typography>
      </CardContent>
    </Card>
  </Container>
)
};;